export enum RegisterNoticeFormFields {
  Title = 'title',
  Content = 'content',
  DeleteFileIdList = 'deleteFileIdList',
}

export type TRegisterNoticeForm = {
  [RegisterNoticeFormFields.Title]: string;
  [RegisterNoticeFormFields.Content]: string;
  [RegisterNoticeFormFields.DeleteFileIdList]?: number[] | null;
};

export type TNoticeFileList = {
  noticeFileId: number;
  path: string;
  originFileName: string;
};
